<!-- todo: split content to components with own logic -->
<!-- todo:  -->
<template>
    <div>
        <Navbar/>
        <carousel :items="1" :nav="false" :dots="false" :loop="false" :autoplay="false">
            <template slot="prev"><span class="prev" style="display: none">prev</span></template>
            <template slot="next"><span class="next" style="display: none">next</span></template>
            <CountdownSlide/>
            <VisualizeSlide/>
            <!-- <CalculationSlide/> -->
            <PreSchoolInfoSlide/>
            <BwnSlide/>
        </carousel>
    </div>
</template>

<script>
    import carousel from 'vue-owl-carousel';
    import Navbar from './Navbar';
    import CountdownSlide from './slides/CountdownSlide';
    import VisualizeSlide from './slides/VisualizeSlide';
    import PreSchoolInfoSlide from './slides/PreSchoolInfoSlide';
    import BwnSlide from './slides/BwnSlide';

    export default {
        name: 'PvCarousel',
        components: {
            carousel,
            Navbar,
            CountdownSlide,
            VisualizeSlide,
            PreSchoolInfoSlide,
            BwnSlide,
        },
        props: {},
        methods: {},
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .owl-carousel div.slide {
        min-height: 70vh;
        margin-top: 30px;
    }
</style>
